export default function About() {
  return (
    <div className="min-h-screen bg-cream-100">

      {/* Hero with image */}
      <div className="relative h-64 lg:h-80 overflow-hidden">
        <img
          src="/images/optimized/IMG_5168.webp"
          fetchPriority="high"
          className="h-full w-full object-cover"
          alt="Scenic Solitude"
        />
        <div className="absolute inset-0 bg-forest-950/55" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <p className="text-[10px] tracking-[0.35em] uppercase text-white/55 font-semibold mb-3">Our Story</p>
          <h1 className="text-4xl font-semibold text-white tracking-tight">About Scenic Solitude</h1>
          <p className="mt-2 text-sm text-white/60">Sojha · Kullu District · Himachal Pradesh · 2,700m</p>
        </div>
      </div>

      {/* Body */}
      <div className="mx-auto max-w-3xl px-8 lg:px-16 py-20">

        <p className="label-aman">The Place</p>
        <h2 className="heading-aman mb-8">Born from the Forest</h2>

        <div className="space-y-6 text-sm text-ink-soft leading-[1.9]">
          <p>
            Scenic Solitude sits 2,700 meters high above Sojha, where the forest meets the sky.
            It is a quiet space built around the peaceful rhythm of the mountains.
          </p>
          <p>
            Every room and treehouse is shaped by hand from local timber and stone to preserve the
            land. Here, life is intentionally slow. You can feel it in the mountain spring water
            heated by the sun, and taste it in daily meals made with ingredients from the valley.
          </p>
          <p>
            The only wi-fi password we offer is a sunrise you won't forget.
          </p>
        </div>

        <div className="mt-16 border-t border-cream-300 pt-16">
          <p className="label-aman">Getting Here</p>
          <h2 className="heading-aman mb-8">Finding Us</h2>
          <div className="space-y-8">
            {[
              {
                mode: 'By Air',
                info: 'Bhuntar Airport (Kullu-Manali) is 90 minutes by road. Transfers can be arranged on request.',
                icon: (
                  <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0 text-ink-muted" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 00-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
                  </svg>
                ),
              },
              {
                mode: 'By Road',
                info: '250 km from Chandigarh via NH-3. The Beas valley drive is part of the experience.',
                icon: (
                  <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0 text-ink-muted" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v9a2 2 0 01-2 2h-2"/>
                    <circle cx="7.5" cy="17.5" r="2.5"/>
                    <circle cx="17.5" cy="17.5" r="2.5"/>
                  </svg>
                ),
              },
              {
                mode: 'By Bus',
                info: 'HRTC operates daily services from Chandigarh and Manali direct to Sojha.',
                icon: (
                  <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0 text-ink-muted" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2"/>
                    <path d="M2 11h20M7 3v14M17 3v14"/>
                    <circle cx="7" cy="20" r="1.5"/>
                    <circle cx="17" cy="20" r="1.5"/>
                    <path d="M7 21.5H5M17 21.5h2"/>
                  </svg>
                ),
              },
            ].map(item => (
              <div key={item.mode} className="flex gap-6 border-t border-cream-300 pt-8 items-start">
                <div className="flex flex-col items-center gap-2 shrink-0 w-20">
                  {item.icon}
                  <p className="text-[11px] tracking-widest2 uppercase text-ink-muted">{item.mode}</p>
                </div>
                <p className="text-sm text-ink-soft leading-relaxed">{item.info}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  )
}
